export default "__VITE_ASSET__7ljYrawU__"